module.exports = __webpack_public_path__ + "imgesssyaa/svg/User.622354b0.svg";